import Script from 'next/script';

export const ApplePayScript = () => {
  return (
    <Script
      src="https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js"
      strategy="afterInteractive"
    />
  );
};
